import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "../pages/home"
import SearchJobsPage from "../pages/search-jobs"
// import SearchJobsPage1 from "../pages/search-jobs1"
import MyJobsPage from "../pages/my-jobs";
import InterestedJobsPage from "../pages/interested-jobs";
import DocsAndTasksPage from "../pages/docAndTasks";
import EmailAndAlertsPage from "../pages/emailsAndAlerts";
import MyTeamPage from "../pages/myTeam";
import AcknowledgementsPage from "../pages/acknowledgements";
import OnboardingPage from "../pages/onboarding";
import PersonalInfoPage from "../pages/personal-info";
import WorkHistoryPage from "../pages/workHistory";
import ReferencesPage from "../pages/references";
import EducationPage from "../pages/education";
import CheckListsPage from "../pages/checklists";
import ProfessionalInfoPage from "../pages/professional-info";
import UpdateSkillsPage from "../pages/updateskills";
import JobDetailsPage from "../pages/job-details";

const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<HomePage />} path="/"></Route>
                <Route element={<SearchJobsPage />} path="/search-jobs"></Route>
                {/* <Route element={<SearchJobsPage1 />} path="/search-jobs1"></Route> */}
                <Route element={<MyJobsPage />} path="/jobs/my"></Route>
                <Route element={<InterestedJobsPage />} path="/jobs/interested"></Route>
                <Route element={<DocsAndTasksPage />} path="/document-assignments/contract-documents"></Route>
                <Route element={<EmailAndAlertsPage />} path="/prefences"></Route>
                <Route element={<MyTeamPage />} path="/my-team"></Route>
                <Route element={<AcknowledgementsPage />} path="/acknowledgements"></Route>
                <Route element={<OnboardingPage />} path="/onboarding"></Route>
                <Route element={<PersonalInfoPage />} path="/personal-info"></Route>
                <Route element={<WorkHistoryPage />} path="/work-history"></Route>
                <Route element={<EducationPage />} path="/education"></Route>
                <Route element={<ReferencesPage />} path="/references"></Route>
                <Route element={<CheckListsPage />} path="/checklists"></Route>
                <Route element={<ProfessionalInfoPage />} path="/professional-info"></Route>
                <Route element={<UpdateSkillsPage />} path="/updateSkills"></Route>
                <Route element={<JobDetailsPage />} path="/job-details"></Route>
            </Routes>
        </BrowserRouter>
    )
}

export default AppRouter